import { ProtectedSidebarLink, ProtectedSidebarLinkGroup } from '@britishcouncil/react-admin';
import { useLocation } from 'react-router';

import { ROUTING_PATHS } from 'const';

export const ReportsSidebar = () => {
  const { pathname } = useLocation();
  const {
    reports: {
      path: basePath,
      requiresAny,
      certificationsDue,
      eorSpeakingMonitoring,
      examiners,
      monitoringsDue,
      osmWritingMonitoring,
      trainingAndStandardisation,
      disciplinaryActionDue,
      odpAssessment,
      odpMonitoring,
    },
  } = ROUTING_PATHS;

  return (
    <ProtectedSidebarLinkGroup
      requiresAny={requiresAny}
      name="Reports"
      icon="folder"
      expanded={pathname.startsWith(basePath)}
    >
      <ProtectedSidebarLink {...certificationsDue} name="Certifications Due" icon="file outline" />
      <ProtectedSidebarLink {...monitoringsDue} name="Monitoring Due" icon="file outline" />
      <ProtectedSidebarLink {...osmWritingMonitoring} name="OSM Monitoring" icon="file outline" />
      <ProtectedSidebarLink {...eorSpeakingMonitoring} name="EOR Monitoring" icon="file outline" />
      <ProtectedSidebarLink {...odpMonitoring} name="ODP Monitoring" icon="file outline" />
      <ProtectedSidebarLink {...examiners} name="Examiners" icon="file outline" />
      <ProtectedSidebarLink
        {...trainingAndStandardisation}
        name="Training & Standardisation"
        icon="file outline"
      />
      <ProtectedSidebarLink
        {...disciplinaryActionDue}
        name="Disciplinary Action Due"
        icon="file outline"
      />
      <ProtectedSidebarLink {...odpAssessment} name="ODP Assessment" icon="file outline" />
    </ProtectedSidebarLinkGroup>
  );
};
